export const CASINO_RACE_QUERY = `
  query CasinoRace($slug: String, $limit: Int) {
    casinoRace(slug: $slug, limit: $limit) {
      id
      slug
      title
      description
      type
      status
      dateFrom
      dateTo
      totalEntries
      currentUser {
        rank
        previousRank
        userId
        username
        country
        countryName
        avatarUrl
        amount
        previousAmount
        isCurrentUser
        prize {
          rank
          text
          total
          totalNumber
        }
      }
      top {
        rank
        previousRank
        userId
        username
        country
        countryName
        avatarUrl
        amount
        previousAmount
        isCurrentUser
        prize {
          rank
          text
          total
          totalNumber
        }
      }
      leaderboard {
        rank
        previousRank
        userId
        username
        country
        countryName
        avatarUrl
        amount
        previousAmount
        isCurrentUser
        prize {
          rank
          text
          total
          totalNumber
        }
      }
      prizes {
        rank
        text
        total
        totalNumber
      }
    }
  }
`;
